//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { BillingProfileDefaultMode } from './Enums';

export class TestBillingProfileInputItem extends ItemBase {
    DefaultBillingMode: BillingProfileDefaultMode = BillingProfileDefaultMode.None;
    StudentIndex: number = 0;
    TeacherIndex: number = 0;
    EventIndex: number | null = null;
    LessonDuration: number | null = null;
    MakeUpMinutes: number | null = null;
    EventCategoryIndex: number | null = null;

    constructor(initializer?: Partial<TestBillingProfileInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestBillingProfileInputItem";
}
